<template>
</template>

<script setup>
const route = useRoute();

const { currentTag } = useTags()
const tagUrl = ref(route.params.tag);

definePageMeta({
	layout: "serverlist",
	name: "tag-page"
})

let metaTagName = encodeHTML(currentTag?.value?.name ?? tagUrl.value);
let metaTagNameLower = encodeHTML(
	currentTag?.value?.name ? currentTag?.value?.name.toLowerCase() : tagUrl.value ? tagUrl.value.toLowerCase() : "");

const meta = {
	title: `Minecraft ${metaTagName} Servers | MCIP List`,
	ogTitle: `Minecraft ${metaTagName} Servers | MCIP List`,
	description: currentTag?.value?.description ||
		`Some of the best Minecraft ${metaTagName} Servers can be found here. These ${metaTagName} Minecraft Servers are listed by player votes`,
	ogDescription: currentTag?.value?.description ||
		`Some of the best Minecraft ${metaTagName} Servers can be found here. These ${metaTagName} Minecraft Servers are listed by player votes`,
	keywords: `minecraft ${metaTagNameLower} servers, ${metaTagNameLower} mc servers, best minecraft ${metaTagNameLower} servers, ${metaTagNameLower} minecraft server ip`
};

if (route.params.page) {
	meta.robots = "noindex";
}

useSeoMeta(meta);

useHead({
	link: [
		{
			rel: "canonical",
			href: "https://www.minecraftiplist.com/server-tags/" + (currentTag?.value?.urlname ?? tagUrl.value),
		},
	],
});
</script>